import { Auth } from "aws-amplify";

const resendConfirmCode = async (email: string) => {
  await Auth.resendSignUp(email);
};

export default resendConfirmCode;
